import React from 'react';
import MarkdownDocPage from '../MarkdownDocPage';

export default function UserManualSettingsPage() {
    return <MarkdownDocPage title="Settings" markdownUrl="/docs/user-manual/pages/settings.md" />;
}

